import React, {useState} from 'react';
import {Button, Spin} from 'antd';
import "./noConnectedWallet.less"
import {ConnectWalletModal} from "../connectWalletModal";
import {Web3Store} from '../../stores/web3Store';
import {observer} from 'mobx-react';
import {WalletIcon} from "./walletIcon";

interface IProps {
    web3Store: Web3Store
}

const renderText = (web3Store: Web3Store) => {

    const {chain, supportedChains} = web3Store;

    if (!chain) {
        return null
    }

    if (!supportedChains.some(x => x.chainId === chain!.chainId)) {
        return <div className='wrong-chain-text'>
            <div>{`You connected to ${chain!.name}.`}</div>
            <div>Please connect to the appropriate network.</div>
            {supportedChains.map(x => x.name).join(', ')}
        </div>
    }
}

export const NoConnectedWalletImpl = ({web3Store}: IProps) => {
    const [isWalletVisible, setIsWalletVisible] = useState(false);

    const onCancel = () => {
        setIsWalletVisible(false);
    };

    if (!web3Store.isReady) {
        return <Spin/>
    }

    return <div className={"no-connected-wallet-wrapper"}>
        <div className='no-connected-wallet'>

            <div>
                <WalletIcon/>
            </div>

            {renderText(web3Store)}

            <Button style={{marginTop: 15}} className="myth-button" size='large' type="primary"
                    onClick={() => setIsWalletVisible(true)}>
                Connect your WEB 3.0 wallet
            </Button>
            <ConnectWalletModal
                web3Store={web3Store}
                visible={isWalletVisible}
                onCancel={onCancel}/>
        </div>
    </div>
}

export const NoConnectedWallet = observer(NoConnectedWalletImpl)
